import { ComponentHealthWrapFn, createComponentHealth } from '@shared/components/ComponentHealth';

const COMPONENT_SLOW_LOG_TIMEOUT_MS = 10_000;

const [wrapWithAccommodationsConsoleRoot, useAccommodationsConsoleHealthRoot] = createComponentHealth('AccommodationsConsole');

export const wrapWithAccommodationsConsoleProvider: ComponentHealthWrapFn = <T extends {}>(Component: React.ComponentType<T>) => {
  const wrappedWithRoot = wrapWithAccommodationsConsoleRoot(Component);
  return (props: T) =>
    wrappedWithRoot({
      slowLogTimeout: COMPONENT_SLOW_LOG_TIMEOUT_MS,
      forceErrorUIOnTimeout: false,
      telemetryEvent: 'TravelButtonInteracted',
      ...props,
    });
};

export const useAccommodationsConsoleHealth = () => {
  const { onLoadComplete, onLoadFailure } = useAccommodationsConsoleHealthRoot();

  return {
    onLoadComplete: () => {
      onLoadComplete();
    },
    onLoadFailure: (reason: unknown, context?: object) => {
      onLoadFailure(reason, context);
    },
  };
};
